import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { DownloadTypeService } from "../shared";

@Component({
  selector: "download-type-list",
  templateUrl: "./download-type-list.component.html",
  styleUrls: ["./download-type-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class DownloadTypeListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: DownloadTypeService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      "Tipos de Descarga - " + this.mainConfig.cmsName
    );
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/download-type-list/download-type-list.component.ts